import { Card, CardContent, Grid, Stack, Typography } from "@mui/material";
import { MprcButton } from "components/MprcButton";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { SessionService } from "services/sessionService";

export const PageNotFound: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <Grid container direction="column" justifyContent="flex-start" alignItems="center" spacing={2} minHeight="70vh">
            <Grid>
                <img
                    src={SessionService.current.appImages.highlightImageUrl}
                    width="360"
                />
            </Grid>
            <Grid>
                <Card>
                    <CardContent>
                        <Stack direction="column" alignItems="center">
                            <div>
                                <Typography variant="h1">
                                    {t("Public.PageNotFound.HeaderTitle")}
                                </Typography>
                                <Typography variant="body1">
                                    <p>{t("Public.PageNotFound.Msg1")}</p>
                                </Typography>
                            </div>
                            <MprcButton
                                variant="outlined"
                                onClick={() => navigate("/", { replace: true })}
                            >
                                {t("Public.Common.HomeButton")}
                            </MprcButton>
                        </Stack>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    );
};
